import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const { t } = useTranslation();
  const { login } = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      login(token);
      // Clear the URL parameters and redirect to home
      window.history.replaceState({}, document.title, '/');
    }
  }, [login]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '1.2rem',
      color: '#666'
    }}>
      {t('common:loggingIn')}
    </div>
  );
};

export default AuthCallback;